export const DeviceRowType = Object.freeze({
    BASIC: Symbol("basic"),
    RIGHT_DETAIL_AND_SUBTITLE: Symbol("right_detail_and_subtitle"),
    SWITCH: Symbol("switch"),
    NEW: Symbol("new"),
    TWO_CONTROLS: Symbol("two_controls"),
    AUTOSUGGEST: Symbol("autosuggest"),
    EMPTY: Symbol("empty"),
});
